import { MemreButton, MemreFlexBox, MemreText } from 'components/core';
import { useDeletePartnerUserRole } from 'hooks/useDeletePartnerUserRole';
import { usePartnerUserRoles } from 'hooks/usePartnerUserRoles';
import { useStaffStore } from 'pages/admin-dashboard/staff/store';
import { InviteStaff } from 'pages/admin-dashboard/staff/InviteStaff';
import { RoleInfoModal } from 'pages/admin-dashboard/staff/RoleInfoModal';
import { useState } from 'react';
import { pluralize } from 'utils/stringUtils';

export const Header = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isRoleInfoModalOpen, setIsRoleInfoModalOpen] = useState(false);
  const [deletePartnerUserRole] = useDeletePartnerUserRole();
  const { data: response, refetch } = usePartnerUserRoles();
  const staff = response?.data || [];
  const { rowSelection, setRowSelection } = useStaffStore();
  const selectedCount = Object.keys(rowSelection).length;

  const handleBulkDelete = async () => {
    if (!selectedCount || !staff.length) return;

    if (!window.confirm('Are you sure you want to remove selected staff members?')) {
      return;
    }

    try {
      // By default, each row's ID is its array index in React Table,
      // so rowSelection keys are numeric indices.
      const selectedRowIndices = Object.keys(rowSelection).map((k) => Number(k));
      const selectedUsers = selectedRowIndices.map((idx) => staff[idx]).filter(Boolean);

      await Promise.all(
        selectedUsers.map((u) =>
          deletePartnerUserRole({
            partnerUserRoleId: u.id,
          })
        )
      );

      setRowSelection({});
      refetch();
    } catch (error) {
      console.error('Error in bulk delete:', error);
    }
  };

  return (
    <>
      <MemreFlexBox gap={4} direction="row" justify="space-between" align="center">
        <MemreText variant="h3">Staff</MemreText>
        <MemreFlexBox gap={2} direction="row" align="center">
          {selectedCount > 0 && (
            <MemreButton
              text={`Remove ${pluralize(selectedCount, 'user')}`}
              size="small"
              color="error"
              variant="contained"
              onClick={handleBulkDelete}
            />
          )}
          <MemreButton
            text="Role Details"
            variant="text"
            onClick={() => setIsRoleInfoModalOpen(true)}
            color="secondary"
            iconName="questionMark"
            size="small"
          />
          <MemreButton
            text="Invite Staff"
            variant="outlined"
            onClick={() => setIsModalOpen(true)}
            color="secondary"
            iconName="paperPlane"
            size="small"
          />
        </MemreFlexBox>
      </MemreFlexBox>

      {isModalOpen && <InviteStaff setIsModalOpen={setIsModalOpen} />}
      {isRoleInfoModalOpen && <RoleInfoModal setIsModalOpen={setIsRoleInfoModalOpen} />}
    </>
  );
};
